import { Dispatch, SetStateAction } from 'react';
import { ICaseBattleGame } from '@/utils/types/ICaseBattle';
import BasePlayers from '@/components/CaseBattles/BasePlayers';
import GameBattleAvatarPlaceholder from '@/components/CaseBattles/Game/Avatar/GameBattleAvatarPlaceholder';

interface Props {
    game: ICaseBattleGame;
    setTeam: Dispatch<SetStateAction<undefined | number>>;
    curTeam?: number;
}

const JoinBattlePlayers = ({ game, setTeam, curTeam }: Props) => {
    const Placeholder = ({ teamId }: { teamId: number }) => (
        <button
            type="button"
            onClick={() => setTeam(teamId)}
            className="cursor-pointer transition-transform hover:scale-105"
            aria-label={`Choose team ${teamId}`}
        >
            <GameBattleAvatarPlaceholder
                borderColor={curTeam === teamId ? '#ffb13d' : undefined}
            />
        </button>
    );

    return (
        <div className="flex justify-center">
            <BasePlayers game={game} placeholder={(teamId) => <Placeholder teamId={teamId} />} />
        </div>
    );
};

export default JoinBattlePlayers;
